import React, { useState } from "react";
import { useFormik } from "formik";

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "14px",
};

const rowStyle = {
  display: "flex",
  gap: "20px",
  flexWrap: "wrap",
};

const groupStyle = {
  flex: "1",
  display: "flex",
  flexDirection: "column",
  gap: "6px",
};

const DiscountForm = () => {
  const [lockDiscount, setLockDiscount] = useState(false);

  const formik = useFormik({
    initialValues: {
      mrp: "",
      netRate: "",
      marginBefore: "",
      minSaleDiscount: "",
      marginMin: "",
      maxSaleDiscount: "",
      marginMax: "",
      listedOnline: false,
      onlineDiscount: "",
    },
    onSubmit: (values) => {
      console.log("Discount Data:", values);
    },
  });

  const inputHeight = "38px"; // consistent field height

  const getInputStyle = (field) => ({
    padding: "8px 10px",
    borderRadius: "5px",
    border: "1px solid #dedede",
    fontSize: formik.values[field] ? "15px" : "13px",
    color: formik.values[field] ? "#000000ff" : "#333",
    backgroundColor: "#fff",
    transition: "all 0.2s ease-in-out",
    height: inputHeight,
  });

  const toggleContainer = {
    ...getInputStyle("lockProductDiscount"),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  };

  const toggleSwitch = {
    width: "40px",
    height: "20px",
    borderRadius: "20px",
    position: "relative",
    transition: "all 0.3s ease",
    backgroundColor: lockDiscount ? "#1db954" : "#ccc",
  };

  const toggleCircle = {
    width: "16px",
    height: "16px",
    backgroundColor: "#fff",
    borderRadius: "50%",
    position: "absolute",
    top: "2px",
    left: lockDiscount ? "22px" : "2px",
    transition: "all 0.3s ease",
  };

  return (
    <form style={formStyle} onSubmit={formik.handleSubmit}>
      {/* Row 1: MRP, NET Rate, Margin Before, Lock Discount */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>MRP (incl gst)</label>
          <input
            type="text"
            name="mrp"
            placeholder="Enter MRP Value"
            style={getInputStyle("mrp")}
            value={formik.values.mrp}
            onChange={formik.handleChange}
          />
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>NET Rate (incl gst)</label>
          <input
            type="text"
            name="netRate"
            placeholder="Enter NET Value"
            style={getInputStyle("netRate")}
            value={formik.values.netRate}
            onChange={formik.handleChange}
          />
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Margin (Before Discount)</label>
          <input
            type="text"
            name="marginBefore"
            placeholder="Enter Margin Value"
            style={getInputStyle("marginBefore")}
            value={formik.values.marginBefore}
            onChange={formik.handleChange}
          />
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Lock Product Discount</label>
          <div style={toggleContainer} onClick={() => setLockDiscount(!lockDiscount)}>
            <span style={{ fontSize: "13px", color: "#333" }}>Lock Product Discount</span>
            <div style={toggleSwitch}>
              <div style={toggleCircle}></div>
            </div>
          </div>
        </div>
      </div>

      {/* Row 2: Min Sale Discount + Margin */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            Min Sale Discount <span style={{ color: "#888" }}>(Optional)</span>
          </label>
          <input
            type="text"
            name="minSaleDiscount"
            placeholder="Enter Min Sale Discount"
            style={getInputStyle("minSaleDiscount")}
            value={formik.values.minSaleDiscount}
            onChange={formik.handleChange}
          />
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Margin (After Min Discount)</label>
          <input
            type="text"
            name="marginMin"
            placeholder="Enter Margin Value"
            style={getInputStyle("marginMin")}
            value={formik.values.marginMin}
            onChange={formik.handleChange}
          />
        </div>
      </div>

      {/* Row 3: Max Sale Discount + Margin */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            Max Sale Discount <span style={{ color: "#888" }}>(Optional)</span>
          </label>
          <input
            type="text"
            name="maxSaleDiscount"
            placeholder="Enter Max Sale Discount"
            style={getInputStyle("maxSaleDiscount")}
            value={formik.values.maxSaleDiscount}
            onChange={formik.handleChange}
          />
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Margin (After Max Discount)</label>
          <input
            type="text"
            name="marginMax"
            placeholder="Enter Margin Value"
            style={getInputStyle("marginMax")}
            value={formik.values.marginMax}
            onChange={formik.handleChange}
          />
        </div>
      </div>

      {/* Row 4: Online Store + Discount */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Online Store</label>
          <div
            style={{
              ...getInputStyle("listedOnline"),
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
            onClick={() =>
              formik.setFieldValue("listedOnline", !formik.values.listedOnline)
            }
          >
            <input
              type="checkbox"
              name="listedOnline"
              checked={formik.values.listedOnline}
              onChange={formik.handleChange}
              style={{
                width: "16px",
                height: "16px",
                cursor: "pointer",
                accentColor: "#1db954",
              }}
            />
            <span style={{ fontSize: "13px", color: "#333" }}>
              Listed on Online Store
            </span>
          </div>
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            Online Discount <span style={{ color: "#888" }}>(Optional)</span>
          </label>
          <input
            type="text"
            name="onlineDiscount"
            placeholder="Enter Online Discount"
            style={getInputStyle("onlineDiscount")}
            value={formik.values.onlineDiscount}
            onChange={formik.handleChange}
          />
        </div>
      </div>
    </form>
  );
};

export default DiscountForm;
